<template>
  <v-dialog persistent v-model="dialogAlterarSenha" max-width="600px">
    <v-card style="border: 1px solid #fff">
      <v-toolbar dark flat color="#042333" height="50px">
        <v-toolbar-title class="subtitle-1">{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="onReset">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pb-0">
        <v-container fill-height fluid>
          <v-row align="center" justify="center" style="min-height: 55vh">
            <v-col class="px-10 pb-0">
              <v-text-field
                v-model.trim="form.password"
                :error-messages="passwordErrors"
                autofocus
                outlined
                label="Nova Senha*"
                type="password"
                autocomplete="new-password"
                @input="$v.form.password.$touch()"
                @blur="$v.form.password.$touch()"
              ></v-text-field>
              <v-text-field
                v-model.trim="form.repeatPassword"
                :error-messages="repeatErrors"
                outlined
                label="Confirmar Senha*"
                type="password"
                @input="$v.form.repeatPassword.$touch()"
                @blur="$v.form.repeatPassword.$touch()"
              ></v-text-field>
              <small>* Indica Campos Obrigatórios</small>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="white" @click="onReset()">Cancelar</v-btn>
        <v-btn color="#042333" dark @click="save">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, sameAs, minLength } from "vuelidate/lib/validators";
import { mapMutations } from "vuex";
import UsuarioAPI from "./../../api/usuario";

export default {
  data() {
    return {
      title: "Alterar Senha",
      form: {
        password: "",
        repeatPassword: ""
      }
    };
  },
  validations: {
    form: {
      password: { required, minLength: minLength(6) },
      repeatPassword: { sameAsPassword: sameAs("password") }
    }
  },
  computed: {
    dialogAlterarSenha: {
      get() {
        return this.$store.state.app.dialogAlterarSenha;
      },
      set(val) {
        this.$store.commit("app/setDialogAlterarSenha", val);
      }
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.form.password.$dirty) return errors;
      !this.$v.form.password.required && errors.push("A senha é obrigatória.");
      !this.$v.form.password.minLength &&
        errors.push("A senha deve ser maior que 6 caracteres");
      return errors;
    },
    repeatErrors() {
      const errors = [];
      if (!this.$v.form.repeatPassword.$dirty) return errors;
      !this.$v.form.repeatPassword.sameAsPassword &&
        errors.push("As senhas devem ser iguais.");
      return errors;
    }
  },
  methods: {
    ...mapMutations("app", ["setDrawerMenu", "setDialogAlterarSenha"]),

    save() {
      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();
        const params = {
          password: this.form.password
        };
        this.$store.dispatch(
          "loading/addRequisicao",
          UsuarioAPI.updatePass(headers, params)
            .then(response => {
              const token = response.data.token;
              localStorage.setItem("token", token);
              this.onReset();
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },
    onReset() {
      this.form.password = "";
      this.form.repeatPassword = "";
      this.$v.$reset();
      this.setDialogAlterarSenha(false);
    }
  }
};
</script>
